/*----- Core -----*/
import styled from 'styled-components'

/*----- Commons -----*/
import Color      from '../../commons/Color'
import Montserrat from '../../commons/mixins/fonts/Montserrat'

/*----- Export -----*/
export default styled.main`

	display: flex;
	flex-direction: column;
	padding-top: 64px;

	.illustration__image {
		width: 60%;
	}
	.illustration__paragraph {
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		margin: 32px 0;
		p {
			${ Montserrat(16, 600, Color.main) };
			text-align: center;
			max-width: 200px;
		}
		img {
			width: 32px;
		}
	}

	.contact-form-container {
		max-width: 400px;
		width: 100%;
		background: white;
		border-radius: 8px;
		display: flex;
		justify-content: center;
		align-items: center;
		min-height: 400px;
		form {
			width: 100%;
		}
		.handler-button {
			max-width: 100%;
			width: 100%;
		}
	}

	.team-philosophy {
		.team-philosophy__data-container {
			background-color: white;
			border-radius: 12px;
		}
		.team-philosophy__list {
			list-style: none;
			li {
				${ Montserrat(14, 600, Color.main) };
			}
		}
	}
`